import $ from 'jquery';
import { gsap } from "gsap";

class BannerImageItem {
    constructor(el, i) {

        this.render(el);
    }


    prime(id) {
        console.log(id)
        var element = $(id);
        if (element.css('background-image') === 'none') {
            console.log(element.data('src'), `url('${element.data('src')}')`)
            element.css('background-image', `url('${element.data('src')}')`);
        }
    }

 

    setNewImage(e) {
        console.log('set new image', e);
        var $thisPage = $(e).data('triggerFor');

        var pageToMoveTo = $($thisPage);

        if (this.tl){
           this.tl.kill();
        }
       
        this.tl = new gsap.timeline();
        this.tl.set(this.imageCanvases.not($thisPage), {   opacity: 0 });
        this.tl.set(this.currentPage, { zIndex: 1, opacity: 1 });
        this.tl.set(this.SolidBackground, { zIndex: 2 });
        this.tl.set(pageToMoveTo, { zIndex: 3 });
        this.tl.fromTo(this.SolidBackground, {opacity: 0 }, {opacity:1, duartion: 0.2})
        this.tl.fromTo(pageToMoveTo, { opacity: 0 }, { autoAlpha: 1, duartion: 0.2 }, ">-0.2");

        this.current = $thisPage;
        this.currentPage = pageToMoveTo;
    }

    link_MOUSEENTER(e) {
        var x = $(e.currentTarget);
       
        this.prime(x.data('triggerFor'));
        if (this.current !== x.data('triggerFor')) {

        this.timeout = window.setTimeout(this.setNewImage.bind(this,x), 200);
        }

    }

    link_MOUSELEAVE(e) {
        if (this.timeout) {
            console.log('c')
            window.clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    render(el) {
        this.el = $(el);
        console.log('test')
        this.imageCanvases = this.el.find('[data-ref="c-banner-images-canvas"]').css('opacity', 0);
        this.SolidBackground = this.el.find('[data-ref="c-banner-backdrop"]').css('opacity', 0);

        this.triggers = this.el.find('[data-ref="banner-image-trigger"]');
        this.triggers.on('mouseleave', this.link_MOUSELEAVE.bind(this))
            .on('mouseenter', this.link_MOUSEENTER.bind(this))
    }
    

}

class BannerImage {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new BannerImageItem(el, index);
    }
}

export default BannerImage;
